import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';

interface PageHeaderProps {
	text?: string;
	description?: string;
	wrapperClassname?: string;
	backButtonClassname?: string;
	backButtonText?: string;
	backButtonLink?: string;
}

const MyModulesHeader = ({
	text,
	description,
	wrapperClassname = 'bg-[#101828]',
	backButtonClassname = 'text-[#344054]',
	backButtonText,
	backButtonLink
}: PageHeaderProps) => {
	return (
		<div className={wrapperClassname}>
			<div className="mx-auto flex max-w-[1216px] flex-col gap-4 px-4 py-5 sm:gap-8 sm:py-10 xl:px-0">
				<a href={backButtonLink || '/'}>
					<Button
						variant="secondary"
						size="sm"
						prefixIcon={<FontAwesomeIcon icon={faArrowLeft} className={backButtonClassname} />}
						className={backButtonClassname}
					>
						{backButtonText || 'Back'}
					</Button>
				</a>

				<div className="flex flex-col gap-3">
					<h1 className="text-3xl font-semibold text-white sm:text-4xl">{text}</h1>
					{description && <p className="text-sm font-normal text-[#EAECF0] sm:text-base">{description}</p>}
				</div>
			</div>
		</div>
	);
};

export default MyModulesHeader;
